import React, { useState } from 'react';

import IconFilterDial from '@pkg/assets/icons/filter-dial.svg?react';
import { FilterChips } from '@pkg/components/Filters/FilterChips/FilterChips.tsx';
import { ToggleGrid } from '@pkg/components/Filters/ToggleGrid.tsx';
import { FieldSearch, type FieldSearchProps } from '@pkg/components/forms';
import { type Collectible } from '@pkg/graphql/codegen/graphql';
import { useAppSelector } from '@pkg/hooks/redux/useAppSelector.ts';

import { useNFTsFiltersStore, useNFTsPageStore } from '@app/store/zustand';

import { FiltersModal } from './FiltersModal';

import {
    FiltersButton,
    FixedBottom,
    IconWrapper,
    SearchWrapper,
    SelectAllButton,
    StickyRow,
} from './FiltersMobile.style';

export interface FiltersMobileProps {
    nftEntries?: Collectible[];
}

export function FiltersMobile({ nftEntries }: FiltersMobileProps) {
    const [open, setOpen] = useState(false);

    const isPageOwner = useAppSelector((state) => state.yatPage.isPageOwner);
    const { marketplaceV1Enabled } = useAppSelector((state) => state.featureFlags.features);

    const { isListView, setIsListView, isSelectAll, handleSelectAll } = useNFTsPageStore();
    const search = useNFTsFiltersStore((state) => state.search);
    const setSearch = useNFTsFiltersStore((state) => state.setSearch);

    // TODO: Is it beneficial to use a debounce / useDeferredValue?
    const handleSearch: FieldSearchProps['onChange'] = (newValue = '') => {
        const stringified = newValue.toString();
        setSearch(stringified);
    };

    const userSpecificFilters = isPageOwner ? (
        <FixedBottom>
            <ToggleGrid selected={isListView} setSelected={setIsListView} />

            <SelectAllButton onAction={() => handleSelectAll(nftEntries || [])}>
                {isSelectAll ? 'Select None' : 'Select All'}
            </SelectAllButton>
        </FixedBottom>
    ) : null;

    return (
        <>
            <StickyRow>
                <SearchWrapper>
                    <FieldSearch value={search} placeholder="Search collection or token" onChange={handleSearch} />
                </SearchWrapper>

                <FiltersButton onAction={() => setOpen(true)}>
                    <IconWrapper>
                        <IconFilterDial />
                    </IconWrapper>
                </FiltersButton>
            </StickyRow>

            {marketplaceV1Enabled && userSpecificFilters}

            {/* TODO: Conditionally render within <AnimatePresence /> */}
            <FilterChips filteredResultCount={nftEntries?.length} />

            <FiltersModal open={open} setOpen={setOpen} />
        </>
    );
}
